/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Filter_EquipmentInputs */

const en_us2_exercise_filter_equipment = /** @type {(inputs: Exercise_Filter_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipment`)
};

const pt_br2_exercise_filter_equipment = /** @type {(inputs: Exercise_Filter_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipamento`)
};

const es_419_exercise_filter_equipment = /** @type {(inputs: Exercise_Filter_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipo`)
};

const pt_pt2_exercise_filter_equipment = /** @type {(inputs: Exercise_Filter_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipamento`)
};

const fr_fr2_exercise_filter_equipment = /** @type {(inputs: Exercise_Filter_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Équipement`)
};

const de_de2_exercise_filter_equipment = /** @type {(inputs: Exercise_Filter_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausrüstung`)
};

const it_it2_exercise_filter_equipment = /** @type {(inputs: Exercise_Filter_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attrezzatura`)
};

/**
* | output |
* | --- |
* | "Equipment" |
*
* @param {Exercise_Filter_EquipmentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_filter_equipment = /** @type {((inputs?: Exercise_Filter_EquipmentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Filter_EquipmentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_filter_equipment(inputs)
	if (locale === "es-419") return es_419_exercise_filter_equipment(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_filter_equipment(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_filter_equipment(inputs)
	if (locale === "de-DE") return de_de2_exercise_filter_equipment(inputs)
	if (locale === "it-IT") return it_it2_exercise_filter_equipment(inputs)
	return en_us2_exercise_filter_equipment(inputs)
});
export { exercise_filter_equipment as "exercise.filter_equipment" }